package games.polyclub.website.frontend.store.hooks

import games.polyclub.website.frontend.store.context.UserPreferencesContext
import react.useContext

fun useUserPreferences() = checkNotNull(useContext(UserPreferencesContext)) {
    "UserPreferencesContext indisponível"
}
